"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaybeClassElementMetadataKind = void 0;
var MaybeClassElementMetadataKind;
(function (MaybeClassElementMetadataKind) {
    MaybeClassElementMetadataKind[MaybeClassElementMetadataKind["unknown"] = 32] = "unknown";
})(MaybeClassElementMetadataKind || (exports.MaybeClassElementMetadataKind = MaybeClassElementMetadataKind = {}));
//# sourceMappingURL=MaybeClassElementMetadataKind.js.map